import { TrackedExpandableContext } from '@objectiv/tracker-react';
import { animated, useSpring } from '@react-spring/web';
import { useEffect, useRef, useState } from 'react';

import type { ReactNode } from 'react';

type PropsAnimatedHeight = {
  className?: string;
  trackingId?: string;
  height: `${number}px` | 'auto';
  children: React.ReactNode;
};

const Component: React.FC<{ children: ReactNode }> = ({ children }) => children;

export const AnimatedHeight: React.FC<PropsAnimatedHeight> = (props) => {
  const detailsRef = useRef<HTMLDivElement>(null);
  const refHeight = detailsRef?.current?.offsetHeight;
  const height = props.height === 'auto' ? `${refHeight ?? 0}px` : props.height;

  const [isInitialized, setIsInitialized] = useState(refHeight !== undefined);
  useEffect(() => setIsInitialized(refHeight !== undefined), [refHeight]);

  const style = useSpring({
    height,
    config: { friction: 18, mass: 1 },
    immediate: !isInitialized,
    overflow: 'hidden',
  });

  return (
    <TrackedExpandableContext
      objectiv={{
        id: props.trackingId ?? 'collapsible',
        isVisible: parseInt(props.height) !== 0,
        Component,
      }}
    >
      <animated.div
        style={{
          ...style,
          height: style.height?.to((h) => (parseInt(h) < 0 ? '0px' : h)),
          marginTop: style.height?.to((h) => (parseInt(h) < 0 ? h : '0px')),
        }}
      >
        <div ref={detailsRef} className={props.className}>
          {props.children}
        </div>
      </animated.div>
    </TrackedExpandableContext>
  );
};
